import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown, DropdownMenuItem} from 'views/components';
import {translate} from 'views/module';

import CompactDropdown from './CompactDropdown';

const CallStatusDropdown = (props) => {
  const {selectedStatus, setSelectedStatus} = props;

  const statuses = Object.entries(translate('client.CallStatus'));
  const variant = props.variant || 'default';
  const isCompact = variant === 'compact';
  const dropdownValue = selectedStatus || 'NOT_SCHEDULED';
  const dropdownTitle = translate(`client.CallStatus.${dropdownValue}.Title`);

  const handleOptionSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedStatus(selectedOption);
    }
  };

  return (
    <>
      {
        isCompact &&
        <CompactDropdown
          getOptionKey={([key]) => key}
          getOptionLabel={([, value]) => value.Title}
          isOptionSelected={([key]) => dropdownValue === key}
          label={props.label}
          menuLabel={props.label}
          onOptionSelect={([key]) => handleOptionSelect(key)}
          options={statuses}
          value={dropdownTitle}
        />
      }
      {
        !isCompact &&
          <Dropdown onChange={handleOptionSelect} value={selectedStatus} label={translate('client.ClientDetail.Status.Menu.Subtitles.CallStatus')}>
            {
              statuses.map(([k, v]) => {
                return (
                  <DropdownMenuItem key={k} value={k}>{v.Title}</DropdownMenuItem>
                );
              })
            }
          </Dropdown>
      }
    </>
  );
};

CallStatusDropdown.propTypes = {
  label: PropTypes.string,
  selectedStatus: PropTypes.string,
  setSelectedStatus: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'compact']),
};

export default CallStatusDropdown;
